<!-- course-review.component.html --> 
<app-header></app-header>
<!-- get start card -->
 <div>
  <div class="card-container">
  <div class="card">
    <div class="card-content">
      <h1 class="card-title">Phonics Foundations</h1>
      <p class="card-subtitle">
        This course introduces educators and parents to the essentials of phonics and how it can transform early reading skills in children. Through a clear, practical approach, you will understand why phonics is crucial, how it differs from traditional methods, 
        and how Kaboodle’s systematic approach helps children become confident readers.
      </p>
      <button (click)="onGetStarted()" class="btn-primary">Get Started <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right rigtharr" viewBox="0 0 16 16">
               <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/></svg>
      </button>
    </div>

    <div class="card-image">
      <img src="7.png" alt="Course Image" />
    </div>
  </div>
  </div>

   <!--get start card end-->
<div style="width: auto;background-color: #121212;color: white !important;">
<div class="course-review-container">
  
  <div class="course-header">
    <h1>Kaboodle Phonics: The Key to Early Literacy</h1>
    <div class="course-meta">
      <span class="bestseller">Bestseller</span>
      <span class="rating">4.5 ★ (50,038 ratings)</span>
      <!-- <span class="students">286,483 students</span> -->
    </div>
  </div>
  <div class="course-content">
    <div class="what-youll-learn">
      <h2>What you'll learn</h2>
      <div class="learn-items">
        <div class="learn-column">
          <ul>
            <li>Understand what phonics is and why it is important.</li>
            <li>Explore traditional methods of teaching reading and their limitations.</li>
            <li>Learn about the shift from traditional methods to phonics-based learning.</li>
            <li>Compare the traditional approach with the phonics approach.</li>
            <li>Discover how Kaboodle implements phonics in a structured way.</li>
            <li>Learn about Kaboodle’s systematic approach to teaching phonics.</li>
            <li>Understand step-by-step strategies for phonics instruction.</li>
          </ul>
        </div>
        <div class="learn-column">
          <ul>
            <li>Identify key takeaways for applying phonics in the classroom or at home.</li>
            <li>Reflect on current teaching practices and areas for improvement.</li>
            <li>Gain practical insights for engaging children in reading activities.</li>
            <li>Build confidence in supporting early literacy skills.</li>
            <li>Take actionable steps to make reading fun and effective for children.</li>
          </ul>
        </div>
      </div>
    </div>

  <div class="course-content">
    <h2>Course content</h2>
    <!-- <div class="sections-meta">52 sections • 499 lectures • 36h 57m total length</div> -->
    <button class="expand-all" (click)="expandAll()">Expand all sections</button>
    
    <div class="section-list">
  <!-- Section 1 -->
  <div class="section-item" [class.expanded]="expandedSections[0]">
    <div class="section-header" (click)="toggleSection(0)">
      <div class="section-title">
        <h3>Chapter 1 - Introduction to Phonics</h3>
        <span class="lecture-count">2 lectures • 5min</span>
      </div>
      <span class="toggle-icon">{{ expandedSections[0] ? '−' : '+' }}</span>
    </div>

    <div class="section-details" *ngIf="expandedSections[0]">
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">
            <span class="preview-label">Preview</span>
            Why Phonics Matters: The Basics
          </div>
          <span class="lecture-duration">02:30</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">
            <span class="preview-label">Preview</span>
            Understanding Letter-Sound Relationships
          </div>
          <span class="lecture-duration">02:40</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 2 -->
  <div class="section-item" [class.expanded]="expandedSections[1]">
    <div class="section-header" (click)="toggleSection(1)">
      <div class="section-title">
        <h3>Chapter 2 - Phonics Techniques for Early Readers</h3>
        <span class="lecture-count">5 lectures • 20min</span>
      </div>
      <span class="toggle-icon">{{ expandedSections[1] ? '−' : '+' }}</span>
    </div>

    <div class="section-details" *ngIf="expandedSections[1]">
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Blending Sounds for Simple Words</div>
          <span class="lecture-duration">04:15</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Segmenting Words into Sounds</div>
          <span class="lecture-duration">04:30</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Recognizing Common Phonics Patterns</div>
          <span class="lecture-duration">03:50</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Using Phonics Games for Practice</div>
          <span class="lecture-duration">04:25</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Tips for Parents and Educators</div>
          <span class="lecture-duration">03:20</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 3 -->
  <div class="section-item" [class.expanded]="expandedSections[2]">
    <div class="section-header" (click)="toggleSection(2)">
      <div class="section-title">
        <h3>Chapter 3 - Advanced Phonics Strategies</h3>
        <span class="lecture-count">4 lectures • 18min</span>
      </div>
      <span class="toggle-icon">{{ expandedSections[2] ? '−' : '+' }}</span>
    </div>

    <div class="section-details" *ngIf="expandedSections[2]">
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Decoding Multi-Syllable Words</div>
          <span class="lecture-duration">05:00</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Teaching Irregular Words</div>
          <span class="lecture-duration">04:15</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Phonics Assessment Techniques</div>
          <span class="lecture-duration">04:20</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Tracking Progress and Feedback</div>
          <span class="lecture-duration">04:25</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 4 -->
  <div class="section-item" [class.expanded]="expandedSections[3]">
    <div class="section-header" (click)="toggleSection(3)">
      <div class="section-title">
        <h3>Chapter 4 - Practical Activities and Resources</h3>
        <span class="lecture-count">3 lectures • 15min</span>
      </div>
      <span class="toggle-icon">{{ expandedSections[3] ? '−' : '+' }}</span>
    </div>

    <div class="section-details" *ngIf="expandedSections[3]">
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Interactive Reading Exercises</div>
          <span class="lecture-duration">05:00</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Printable Phonics Worksheets</div>
          <span class="lecture-duration">05:10</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Using Storybooks to Reinforce Skills</div>
          <span class="lecture-duration">05:00</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Section 5 -->
  <div class="section-item" [class.expanded]="expandedSections[4]">
    <div class="section-header" (click)="toggleSection(4)">
      <div class="section-title">
        <h3>Chapter 5 - Course Summary and Next Steps</h3>
        <span class="lecture-count">2 lectures • 8min</span>
      </div>
      <span class="toggle-icon">{{ expandedSections[4] ? '−' : '+' }}</span>
    </div>

    <div class="section-details" *ngIf="expandedSections[4]">
      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Key Takeaways and Best Practices</div>
          <span class="lecture-duration">04:00</span>
        </div>
      </div>

      <div class="lecture-item">
        <div class="lecture-info">
          <div class="lecture-title">Next Steps for Educators and Parents</div>
          <span class="lecture-duration">04:00</span>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
</div>
</div>
</div>
  <!-- Video Player Modal -->
<!-- Add this modal structure (place it at the bottom of your template) -->
<div class="video-modal" *ngIf="showVideoModal">
  <div class="modal-overlay" (click)="closeVideo()"></div>
  <div class="modal-content">
    <button class="close-modal" (click)="closeVideo()">×</button>
    <div class="video-wrapper">
      <iframe
        *ngIf="currentVideo"
        [src]="getSafeVideoUrl(currentVideo)"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        title="Course video player">
      </iframe>
    </div>
  </div>
</div>
<app-footer></app-footer>